import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { FadeIn } from "../../../../../common/components";
import { IconAdmin } from "../../Icons";

interface AdminChipProps {
    isChecked: boolean;
    onToggle: (checked: boolean) => void;
}

const AdminChip = (props: AdminChipProps) => {
    const { isChecked, onToggle } = props;

    const { t } = useTranslation("common");

    return (
        <FadeIn>
            <button
                type="button"
                role="switch"
                aria-checked={isChecked}
                onClick={() => onToggle(!isChecked)}
                className={classNames(
                    "flex cursor-pointer items-center justify-center gap-1.5 md:gap-2 rounded-full size-10 md:h-7 md:w-auto md:pl-2.5 md:pr-3 font-normal text-sm leading-none transition-[background] duration-150 focus-visible:outline-2 focus-visible:outline-surface-500/40",
                    {
                        "bg-surface-500 text-primary-500 hover:bg-surface-520 md:font-semibold":
                            isChecked,
                        "bg-transparent text-primary-text hover:bg-surface-500/16":
                            !isChecked,
                    }
                )}
            >
                <IconAdmin className="size-5.5 md:size-3.25" />
                <span className="hidden md:inline">{t("common:admin")}</span>
            </button>
        </FadeIn>
    );
};

export default AdminChip;
